import Element, { ElementParams } from './element';

import { RGBA, getIntermediateColor } from '../../utils/color';

export interface ParticleParams extends ElementParams {
  range: number; // unit: pixels
  endWidth: number;

  color?: RGBA;
  startColor: RGBA;
  endColor: RGBA;
}

export default class Particle extends Element implements ParticleParams {
  range: number = 10;
  color?: RGBA;
  startColor: RGBA = {R: 255, G: 230, B: 0, A: 1}; // yellow
  endColor: RGBA = {R: 255, G: 0, B: 0, A: 1}; // red
  endWidth: number = 0;

  hasCollision = false;
  moveSpeed = 50;
  width = 100;
  height = 10;

  startWidth: number;
  distanceTraveled = 0; // unit: pixels

  constructor(params: ParticleParams)
  {
    super(params);
    this.applyParams(params);
    this.startWidth = this.width;
  }

  update(modifier: number): Particle
  {
    if (this.distanceTraveled >= this.range)
    {
      this.remove();
      return this;
    }

    const ratio = (this.range - this.distanceTraveled) / this.range;
    const deltaWidth = (this.endWidth - this.startWidth) * (1 - ratio);
    this.width = this.startWidth + deltaWidth;

    this.move(modifier);
    this.distanceTraveled += this.moveSpeed * modifier;

    this.color = getIntermediateColor({
      startColor: this.startColor,
      endColor: this.endColor,
      ratio,
    });

    return this;
  }

  draw(): CanvasRenderingContext2D
  {
    const { x, y, width, color, context } = this;
    if (!color)
      return context;

    context.globalCompositeOperation = 'destination-over'; // draw under the rest of elements
    context.beginPath();
    context.fillStyle = RGBA.toString(color);
    context.arc(x, y, width, 0, Math.PI * 2, true);
    context.closePath();
    context.fill();
    context.globalCompositeOperation = 'source-over'; // default


    return context;
  }
}
